<template>
  <v-container
    v-scroll="onScroll"
    v-show="typeof $route.params.event === 'undefined'"
    fluid
  >
    <v-row
      class="pa-3"
      no-gutter
      v-if="agenda.events && Array.isArray(agenda.events) && agenda.events.length > 0"
    >
      <v-col
        v-for="(item, index) in agenda.events"
        :key="index + '-' + item.id"
        :cols="$vuetify.breakpoint.width >= 1366 ? 6 : 12"
        class="pa-1 ma-0"
      >
        <EventCard :item="item" :index="index" />
      </v-col>
    </v-row>
    <v-row
      no-gutter
      v-if="reload === false
            && typeof agenda.events !== 'undefined'
            && (!Array.isArray(agenda.events) || !agenda.events.length > 0)"
    >
      <v-col cols="8" offset="2" align-center justify-center>
        В указанные дни мероприятий с данной тематикой на выбранных площадках нет.
      </v-col>
    </v-row>
    <v-fade-transition>
      <v-btn
        fixed
        dark
        fab
        bottom
        right
        color="red"
        :small="$vuetify.breakpoint.smAndDown"
        v-show="toptop"
        @click="toTop"
        aria-label="Наверх"
      >
        <v-icon>keyboard_arrow_up</v-icon>
      </v-btn>
    </v-fade-transition>
  </v-container>
<!--
  <div>
    <v-layout v-show="typeof $route.params.event === 'undefined'">
      <v-container fluid grid-list-md text-xs-center v-scroll="onScroll">
        <v-layout fluid row wrap
          v-if="agenda.events && Array.isArray(agenda.events) && agenda.events.length > 0"
        >
          <v-flex
            v-for="(item, index) in agenda.events"
            :key="index + '-' + item.id"
            v-show="showFavorites && item.favorites || !showFavorites && item.visible !== false"
            style="width: 100%;"
            :sm6="$vuetify.breakpoint.width >= 1366"
            xs12 text-xs-left pa-1
            :d-flex="showFavorites && item.favorites || !showFavorites && item.visible"
          >
            <EventCard :item="item" :index="index" />
          </v-flex>
        </v-layout>
        <v-layout
          row wrap fill-height align-center justify-center
          v-if="reload === false
                && typeof agenda.events !== 'undefined'
                && (!Array.isArray(agenda.events) || !agenda.events.length > 0)"
        >
          <v-flex text-uppercase>
            В указанные дни мероприятий с данной тематикой на выбранных площадках нет.
          </v-flex>
        </v-layout>
        <v-fade-transition>
          <v-btn
            fixed
            dark
            fab
            bottom
            right
            color="red"
            :small="$vuetify.breakpoint.smAndDown"
            v-show="toptop"
            @click="toTop"
            aria-label="Наверх"
          >
            <v-icon>keyboard_arrow_up</v-icon>
          </v-btn>
        </v-fade-transition>
        <v-fade-transition>
          <v-btn
            fixed
            dark
            fab
            bottom
            left
            :color="showFavorites ? 'red' : 'primary'"
            :small="$vuetify.breakpoint.smAndDown"
            v-show="favorites.length > 0"
            @click="toggleFavorites"
            :aria-label="showFavorites ? 'Скрыть избранное' : 'Показать избранное'"
          >
            <v-icon>favorite</v-icon>
          </v-btn>
        </v-fade-transition>
      </v-container>
    </v-layout>
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
  </div> -->
</template>

<script>
/* eslint-disable no-param-reassign */
import { mapState } from 'vuex';
import EventCard from '@/components/EventCard.vue';

export default {
  components: {
    // eslint-disable-next-line vue/no-unused-components
    EventCard,
  },
  name: 'Agenda',
  computed: {
    ...mapState(['agenda', 'filters', 'reload', 'favorites', 'showFavorites']),
  },
  watch: {
    favorites: {
      handler(val) {
        if (val.length === 0 && this.showFavorites) {
          this.toggleFavorites();
        }
      },
    },
  },
  data() {
    return {
      toptop: false,
      events: [],
    };
  },
  methods: {
    inFavorites(val) {
      return this.favorites.indexOf(val) !== -1;
    },
    blur(event, ref) {
      if (this.$refs[ref]) this.$refs[ref].blur();
    },
    onScroll: (() => {
      let tm = false;
      return function scroll(e) {
        const self = this;
        window.clearTimeout(tm);
        tm = window.setTimeout(() => {
          if (typeof window === 'undefined') return;
          const top = window.pageYOffset || e.target.scrollTop || 0;
          self.toptop = top > 40;
        }, 250);
      };
    })(),
    toTop() {
      this.$vuetify.goTo(0);
    },
    toggleFavorites() {
      this.$store.dispatch('updateShowFavorites', !this.showFavorites);
    },
  },
  mounted() {
    // window.vuetify = this.$vuetify;
    this.$store.dispatch('updateEvents');
    this.$store.state.initial = 'agenda';
  },
};
</script>

<style lang="scss">
  .v-btn--floating {
    position: relative;
  }

  .item {
    cursor: pointer;
    display: inline-block;
    padding-top: 4px;
    padding-bottom: 4px;
  }
  .eventTitle {
    padding-left: 0px !important;
    padding-top: 0px !important;
    padding-bottom: 0px !important;
  }
  s.v-list__tile {
    height: auto !important;
  }
  s.v-text-field__details {
    display: none !important;
  }
  .v-navigation-drawer__border {
    background-color: rgba(0,0,0,0) !important;
  }
  .pubs {
    position: absolute; top: 0px; right: 0px; bottom: 0px; left: 0px;
  }
</style>
